/**
 * EVORIA GHOST PRODUCT DISCOUNT CONFIGURATION
 *
 * This file maps discount codes to promotion-{product} ghost products.
 * Each promotion product has Seal Subscriptions configured with hardcoded discounts
 * (e.g., "Subscribe & save 15% + TSAOFRIENDS $30 OFF")
 *
 * When a discount code is applied:
 * 1. Look up the promotion product handle from this config
 * 2. Swap the regular product to the promotion product
 * 3. The promotion product's Seal Subscription already has the discounted price
 *
 * This ensures exact recurring subtotal matching for subscription products.
 *
 * The 5 core discount codes work for ALL products (wellness-kit, morning-boost, daily-essentials, night-recovery)
 */

window.EvoriaDiscountConfig = {
  // Map discount codes to their configuration
  // These 5 codes work universally across all products
  discounts: {
    // ========================================================================
    // TSAOFAMSUBS - $75 off subscription products
    // ========================================================================
    'TSAOFAMSUBS': {
      baseHandle: 'wellness-kit',
      description: '$75 off subscription products',
      type: 'fixed',
      value: 75,
      appliesTo: 'subscription',
      perItem: true
    },

    // ========================================================================
    // TSAOFRIENDS - $30 off subscription products
    // ========================================================================
    'TSAOFRIENDS': {
      baseHandle: 'wellness-kit',
      description: '$30 off subscription products',
      type: 'fixed',
      value: 30,
      appliesTo: 'subscription'
    },

    // ========================================================================
    // PIRANTEA_PROMO_1 - Extra discount off subscription products
    // ========================================================================
    'PIRANTEA_PROMO_1': {
      baseHandle: 'wellness-kit',
      description: 'Extra discount off subscription products',
      type: 'percentage',
      value: 15,
      appliesTo: 'subscription'
    },

    // ========================================================================
    // PIRANTEA_PROMO_2 - Extra discount off subscription products
    // ========================================================================
    'PIRANTEA_PROMO_2': {
      baseHandle: 'wellness-kit',
      description: 'Extra discount off subscription products',
      type: 'percentage',
      value: 25,
      appliesTo: 'subscription'
    },

    // ========================================================================
    // PIRANTEA_PROMO_3 - Extra discount off subscription products
    // ========================================================================
    'PIRANTEA_PROMO_3': {
      baseHandle: 'wellness-kit',
      description: 'Extra discount off subscription products',
      type: 'percentage',
      value: 50,
      appliesTo: 'subscription'
    }
  },

  // Selling plan mappings for each product/discount combination
  // All products share the same original selling plan IDs:
  // - 30-day: 6496976996
  // - 90-day: 6496944228
  sellingPlanMaps: {
    'wellness-kit': {
      'TSAOFAMSUBS': {
        promoHandle: 'promotion-wellness-kit',
        sellingPlanMap: {
          6496976996: 6518112356, // 30-day → TSAOFAMSUBS
          6496944228: 6518833252  // 90-day → TSAOFAMSUBS
        }
      },
      'TSAOFRIENDS': {
        promoHandle: 'promotion-wellness-kit',
        sellingPlanMap: {
          6496976996: 6497337444, // 30-day → TSAOFRIENDS
          6496944228: 6493831268  // 90-day → TSAOFRIENDS
        }
      },
      'PIRANTEA_PROMO_1': {
        promoHandle: 'promotion-wellness-kit',
        sellingPlanMap: {
          6496976996: 6512541796, // 30-day → PIRANTEA_PROMO_1
          6496944228: 6512640100  // 90-day → PIRANTEA_PROMO_1
        }
      },
      'PIRANTEA_PROMO_2': {
        promoHandle: 'promotion-wellness-kit',
        sellingPlanMap: {
          6496976996: 6512574564, // 30-day → PIRANTEA_PROMO_2
          6496944228: 6512672868  // 90-day → PIRANTEA_PROMO_2
        }
      },
      'PIRANTEA_PROMO_3': {
        promoHandle: 'promotion-wellness-kit',
        sellingPlanMap: {
          6496976996: 6512607332, // 30-day → PIRANTEA_PROMO_3
          6496944228: 6512705636  // 90-day → PIRANTEA_PROMO_3
        }
      }
    },
    'morning-boost': {
      'TSAOFAMSUBS': {
        promoHandle: 'promotion-morning-boost',
        sellingPlanMap: {
          6496976996: 6517948516, // 30-day → TSAOFAMSUBS
          6496944228: 6517882980  // 90-day → TSAOFAMSUBS
        }
      },
      'TSAOFRIENDS': {
        promoHandle: 'promotion-morning-boost',
        sellingPlanMap: {
          6496976996: 6517981284, // 30-day → TSAOFRIENDS
          6496944228: 6517915748  // 90-day → TSAOFRIENDS
        }
      },
      'PIRANTEA_PROMO_1': {
        promoHandle: 'promotion-morning-boost',
        sellingPlanMap: {
          6496976996: 6518014052, // 30-day → PIRANTEA_PROMO_1
          6496944228: 6517719140  // 90-day → PIRANTEA_PROMO_1
        }
      },
      'PIRANTEA_PROMO_2': {
        promoHandle: 'promotion-morning-boost',
        sellingPlanMap: {
          6496976996: 6518046820, // 30-day → PIRANTEA_PROMO_2
          6496944228: 6517817444  // 90-day → PIRANTEA_PROMO_2
        }
      },
      'PIRANTEA_PROMO_3': {
        promoHandle: 'promotion-morning-boost',
        sellingPlanMap: {
          6496976996: 6518079588, // 30-day → PIRANTEA_PROMO_3
          6496944228: 6517850212  // 90-day → PIRANTEA_PROMO_3
        }
      }
    },
    'daily-essentials': {
      'TSAOFAMSUBS': {
        promoHandle: 'promo-daily-essentials',
        sellingPlanMap: {
          6496976996: 6518177892, // 30-day → TSAOFAMSUBS
          6496944228: 6518341732  // 90-day → TSAOFAMSUBS
        }
      },
      'TSAOFRIENDS': {
        promoHandle: 'promo-daily-essentials',
        sellingPlanMap: {
          6496976996: 6518210660, // 30-day → TSAOFRIENDS
          6496944228: 6518374500  // 90-day → TSAOFRIENDS
        }
      },
      'PIRANTEA_PROMO_1': {
        promoHandle: 'promo-daily-essentials',
        sellingPlanMap: {
          6496976996: 6518243428, // 30-day → PIRANTEA_PROMO_1
          6496944228: 6518407268  // 90-day → PIRANTEA_PROMO_1
        }
      },
      'PIRANTEA_PROMO_2': {
        promoHandle: 'promo-daily-essentials',
        sellingPlanMap: {
          6496976996: 6518276196, // 30-day → PIRANTEA_PROMO_2
          6496944228: 6518440036  // 90-day → PIRANTEA_PROMO_2
        }
      },
      'PIRANTEA_PROMO_3': {
        promoHandle: 'promo-daily-essentials',
        sellingPlanMap: {
          6496976996: 6518308964, // 30-day → PIRANTEA_PROMO_3
          6496944228: 6518472804  // 90-day → PIRANTEA_PROMO_3
        }
      }
    },
    'night-recovery': {
      'TSAOFAMSUBS': {
        promoHandle: 'promotion-night-recovery',
        sellingPlanMap: {
          6496976996: 6518505572, // 30-day → TSAOFAMSUBS
          6496944228: 6518669412  // 90-day → TSAOFAMSUBS
        }
      },
      'TSAOFRIENDS': {
        promoHandle: 'promotion-night-recovery',
        sellingPlanMap: {
          6496976996: 6518538340, // 30-day → TSAOFRIENDS
          6496944228: 6518702180  // 90-day → TSAOFRIENDS
        }
      },
      'PIRANTEA_PROMO_1': {
        promoHandle: 'promotion-night-recovery',
        sellingPlanMap: {
          6496976996: 6518571108, // 30-day → PIRANTEA_PROMO_1
          6496944228: 6518734948  // 90-day → PIRANTEA_PROMO_1
        }
      },
      'PIRANTEA_PROMO_2': {
        promoHandle: 'promotion-night-recovery',
        sellingPlanMap: {
          6496976996: 6518603876, // 30-day → PIRANTEA_PROMO_2
          6496944228: 6518767716  // 90-day → PIRANTEA_PROMO_2
        }
      },
      'PIRANTEA_PROMO_3': {
        promoHandle: 'promotion-night-recovery',
        sellingPlanMap: {
          6496976996: 6518636644, // 30-day → PIRANTEA_PROMO_3
          6496944228: 6518800484  // 90-day → PIRANTEA_PROMO_3
        }
      }
    }
  },

  /**
   * Get promotion product handle for a discount code (case-insensitive)
   * @param {string} code - The discount code
   * @param {string} productHandle - The product handle to get promo for
   * @returns {object|null} { promoHandle, baseHandle, description, type, value, ... }
   */
  getPromoForCode: function(code, productHandle = null) {
    if (!code) return null;

    const normalizedCode = code.toUpperCase().trim();

    // First check main discounts object
    for (const [key, config] of Object.entries(this.discounts)) {
      if (key.toUpperCase() === normalizedCode) {
        // If productHandle is provided, look up the selling plan map
        if (productHandle && this.sellingPlanMaps[productHandle] && this.sellingPlanMaps[productHandle][normalizedCode]) {
          const productMap = this.sellingPlanMaps[productHandle][normalizedCode];
          return {
            code: key,
            ...config,
            promoHandle: productMap.promoHandle,
            baseHandle: productHandle,
            sellingPlanMap: productMap.sellingPlanMap
          };
        }
        return { code: key, ...config };
      }
    }

    return null;
  },

  /**
   * Get the base product handle for a discount code
   * Used to determine which product to swap from
   * @param {string} code - The discount code
   * @returns {string|null} The base product handle
   */
  getBaseHandle: function(code) {
    const discount = this.getPromoForCode(code);
    return discount ? discount.baseHandle : null;
  },

  /**
   * Check if a discount code exists in the configuration
   * @param {string} code - The discount code
   * @returns {boolean} True if the code exists
   */
  hasDiscount: function(code) {
    return this.getPromoForCode(code) !== null;
  },

  /**
   * Validate if a discount can be applied to the current cart
   * @param {object} cart - The cart object
   * @param {string} code - The discount code
   * @returns {object} Validation result { valid, reason }
   */
  validateDiscount: function(cart, code) {
    const discount = this.getPromoForCode(code);

    if (!discount) {
      return { valid: false, reason: 'Invalid discount code' };
    }

    // Check if promoHandle is configured (unless it's shipping)
    if (!discount.promoHandle && discount.type !== 'shipping') {
      return { valid: false, reason: 'Discount not configured - please contact support' };
    }

    // Check subscription vs one-time
    if (discount.appliesTo === 'subscription') {
      const hasSubscription = cart.items.some(item =>
        item.selling_plan_allocation !== null
      );
      if (!hasSubscription) {
        return { valid: false, reason: 'This discount only applies to subscription products' };
      }
    }

    if (discount.appliesTo === 'one-time') {
      const hasOneTime = cart.items.some(item =>
        item.selling_plan_allocation === null
      );
      if (!hasOneTime) {
        return { valid: false, reason: 'This discount only applies to one-time purchase products' };
      }
    }

    return { valid: true };
  },

  /**
   * Get all valid discount codes for a product handle
   * @param {string} productHandle - The product handle
   * @returns {array} Array of discount codes that apply to this product
   */
  getDiscountsForProduct: function(productHandle) {
    const results = [];
    const universalCodes = ['TSAOFAMSUBS', 'TSAOFRIENDS', 'PIRANTEA_PROMO_1', 'PIRANTEA_PROMO_2', 'PIRANTEA_PROMO_3'];

    for (const code of universalCodes) {
      if (this.sellingPlanMaps[productHandle] && this.sellingPlanMaps[productHandle][code]) {
        const config = this.discounts[code];
        const productMap = this.sellingPlanMaps[productHandle][code];
        results.push({
          code,
          ...config,
          promoHandle: productMap.promoHandle,
          baseHandle: productHandle,
          sellingPlanMap: productMap.sellingPlanMap
        });
      }
    }

    return results;
  }
};

// Log for debugging
console.log('[EvoriaDiscountConfig] Loaded with', Object.keys(window.EvoriaDiscountConfig.discounts).length, 'discount codes');
